import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import composition from '@/composition';
import ua from '@/utils/platform';
import { copyTextToClipboard } from '@/utils/regular';
export default {
  props: {
    categories: Array,
    model: Object,
    allowPost: {
      default: true,
      type: Boolean
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;

    function clickOpenApp() {
      if (ua.isMini) {
        copyTextToClipboard(location.href);
        alert('链接复制成功，请您分享给朋友。');
        return;
      }

      if (props.model) {
        openApp();
      } else {
        // 跳转到首页
        openApp(null, true);
      }
    }

    const commonClick2233 = () => {
      if (ua.isAndroid) {
        getAppSearch(null, !props.model);
      } else {
        clickOpenApp();
      }
    };

    const {
      openApp,
      getAppSearch
    } = composition(); // const weapp_username = ref('gh_c0321ea144e0')
    // const weapp_path = ref('/packageNews/pages/index/index')

    expose({
      commonClick2233
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div");
    };
  }

};